import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'twyne-new.ui';
import CustomField from './CustomField';
import { TcpaConsentDbaProvider } from '../tcpaConsentDba/Context';

class CustomFields extends Component {

  state = {
    fields: null
  }

  handleFieldChange = (key, e) => {
    const { onChange, config } = this.props;

    if (e === null){
      onChange(key, '')
    } else if (typeof e === 'boolean' && config[key].type === 'boolean-confirmation') {
      onChange(key, e)
    } else {
      if (['wildcard', 'tcpa-consent-dba'].includes(config[key].type)) return onChange(key, e)
      if (config[key].type.includes('html') || ['color','twyne-url'].includes(config[key].type))
        onChange(key, e);
      else if (e.length > 1){
        let value = []
        value = e.map(el => el.value);
        onChange(key, value);
      } else {
        let value = e.target && e.target.value ? e.target.value : e.value;
        if (config[key].type === 'boolean') 
          value = e.target.checked;
        
        onChange(key, value);
      }
    }
  }

  getFieldConfig = (key) => this.props.config[key];

  componentDidMount(){
    this.setFields()
  }

  setFields = () => {
    const custom = this.props.custom;

    let map = Object.keys(this.props.config).map((key) => { return {key: key, order: this.props.config[key].order || 99999}})

    let sortedConfig = map.sort((a,b) => a.order - b.order)
    const fields = sortedConfig.map((val) => val.key);

    for (let key of fields) {
      if (!custom.hasOwnProperty(key) && this.getFieldConfig(key).defaultValue)
        this.props.onChange(key, this.getFieldConfig(key).defaultValue) 
    }

    this.setState({fields})

  }

  executeConditionalField(field, conditions){
    try {
      var valid = false
      //used for eval
      const current = this.props.custom || {};
      const extra = this.props.extra || {}

      for(let condition of conditions){
        valid = eval(condition)
        if(valid) break
      }
    } catch (e) {
      console.error(`error evaluating conditionon field - ${field}: ${e}`)
      return false
    }
    
    return valid
  }

  render () {
    const fields = this.state.fields
    const {custom, config, extra} = this.props;

    const extraValues = {
      tcpaConsentDba: custom['tcpa-consent-dba'],
      tcpaConsentText: custom['tcpa-consent-text'],
    }

    return (
      <TcpaConsentDbaProvider>
        <Row className={this.props.className || ''}>
          {fields && fields.map(field => {
            let conditions = config[field].condition || undefined
            if (!conditions || this.executeConditionalField(field, conditions)) {
              const { col } = this.getFieldConfig(field)
              return (
                <Col size={col || '12'} key={field}>
                  <CustomField
                    config={this.getFieldConfig(field)}
                    field={field}
                    onChange={this.handleFieldChange}
                    value={custom && custom[field]}
                    extra={extra}
                    extraValues={extraValues}
                  />
                </Col>
              )
            } else {
              return null
            }
          })}
        </Row>
      </TcpaConsentDbaProvider>
    )
  }
}

CustomFields.propTypes = {
  config: PropTypes.object,
  extra: PropTypes.object,
  onChange: PropTypes.func,
  content_type: PropTypes.string
}

export default CustomFields;
